<template>
	<div class="web-page">
		<page-header :minWidth="1280" :userName="userName"></page-header>

		<div class="page-top">
			<UnionActivity />
			<div class="buy-title">{{ title }}</div>
			<div class="tip">
				<span>{{ getConstants('PRICING_NEW_DONT_KNOW') }}</span>
				<a href="https://www.jianguoyun.com/s/helpdesk" target="_blank">{{
					getConstants('PRICING_NEW_DONT_KNOW_ASK')
				}}</a>
			</div>
		</div>
		<Buy></Buy>
		<Profit></Profit>
		<Faq />
		<NutstoreRobot></NutstoreRobot>
		<page-footer></page-footer>
	</div>
</template>
<script>
import Faq from './components/Faq'
import Buy from './components/Buy/index'
import Profit from './components/Profit'
import PageHeader from '../../components/Header'
import PageFooter from '../../components/footer'
import NutstoreRobot from '../../components/robot'
import UnionActivity from './components/UnionActivity/index'
import { getCouponCode, getQueryString } from '../../utils/coupon'
import { signupReportHelper } from '../../utils/signupReportHelper'

export default {
	data() {
		return {
			userName: this.PageInfo.user_name,
			accountExpireLeftTime: 0,
		}
	},
	computed: {
		title() {
			return this.pageTitle || this.getConstants('PRICINF_NEW_SELECT')
		},
	},
	components: {
		Faq,
		Profit,
		Buy,
		PageHeader,
		PageFooter,
		NutstoreRobot,
		UnionActivity,
	},
	mounted() {
		signupReportHelper.reportFromSignupOnce()

		if (getQueryString('coupon_code')) {
			getCouponCode.then(couponData => {
				if (couponData.coupon_code && couponData.isCouponInvalid) {
					this.$message.info({
						content: this.getConstants('COUPON_USED'),
						time: 9000,
					})
				}
			})
		}
	},
}
</script>

<style lang="scss">
@import './style/index.scss';
.web-page {
	background: #fbfbfb;
	width: 100%;
	min-width: 1280px;
}
.page-top {
	padding-top: 60px;
	background: #fbfbfb;
	.tip {
		font-size: 18px;
		line-height: 26px;
		text-align: center;
		color: #aaa;
		a {
			color: #aaa;
			&:hover {
				color: $blue;
			}
		}
	}
	.buy-title {
		padding-top: 48px;
		font-size: 36px;
		line-height: 36px;
		padding-bottom: 24px;
		text-align: center;
	}
}
</style>
